import { render, staticRenderFns } from "./RequestDefault.vue?vue&type=template&id=13093c08&scoped=true&lang=pug&"
import script from "./RequestDefault.vue?vue&type=script&lang=ts&"
export * from "./RequestDefault.vue?vue&type=script&lang=ts&"
import style0 from "./RequestDefault.vue?vue&type=style&index=0&id=13093c08&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13093c08",
  null
  
)

export default component.exports